"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateAdminPage = void 0;
const DataTable_1 = require("@juvare/common-data-table-ui/DataTable");
const shared_1 = require("../../../../backend/features/default-classifiers/shared");
const usePlatformSdkReactTranslation_1 = require("../../../../ui/hooks/usePlatformSdkReactTranslation");
const react_1 = __importDefault(require("react"));
const classifiers_1 = require("../../classifiers");
const storageClientFilter = [{ column: 'type', op: '=', value: 'state' }];
function getEntityTitle(row) {
    return row.columns.name;
}
const EntityDetailsComponent = (props) => {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    return (react_1.default.createElement(classifiers_1.SlideoutFields, { fields: [
            { label: t('common.status'), value: t(`classifiers.statusEnum.${props.response.data.status}`) },
            { label: t('defaultClassifiers.fips'), value: props.response.data.fips ?? '' },
            { label: t('defaultClassifiers.postalCode'), value: props.response.data.postalCode ?? '' },
        ] }));
};
const EntityDetailsComponentWithRegisterState = (props) => {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    return (react_1.default.createElement(classifiers_1.SlideoutFields, { fields: [
            {
                label: t('common.status'),
                value: t(`classifiers.statusEnum.${props.response.data.status}`),
            },
            {
                label: t('defaultClassifiers.registerState'),
                value: props.response.data.registerState != null ? (props.response.data.registerState ? 'Yes' : 'No') : '',
            },
            {
                label: t('defaultClassifiers.fips'),
                value: props.response.data.fips ?? '',
            },
            {
                label: t('defaultClassifiers.postalCode'),
                value: props.response.data.postalCode ?? '',
            },
        ] }));
};
const StateAdminPage = (props) => {
    const { t } = (0, usePlatformSdkReactTranslation_1.usePlatformSdkReactTranslation)();
    const formConfig = (0, classifiers_1.useDefaultFormConfig)({ hideName: true });
    const formConfigWithRegisterState = {
        type: 'form',
        children: [
            ...formConfig.children,
            {
                type: 'form.yesNo',
                key: 'registerState',
                label: 'Register State',
                style: {
                    inline: true,
                },
            },
        ],
    };
    const tableColumns = [
        {
            headerLabel: t('common.name'),
            sortKey: 'name',
            cellFunction: (row) => react_1.default.createElement(DataTable_1.TextCell, null, row.columns.name),
        },
        {
            headerLabel: t('common.status'),
            sortKey: 'status',
            cellFunction: (row) => react_1.default.createElement(DataTable_1.TextCell, null, t(`classifiers.statusEnum.${row.columns.status}`)),
        },
    ];
    const tableColumnsWithRegisterState = [
        tableColumns[0],
        {
            headerLabel: 'Register State',
            sortKey: 'registerState',
            cellFunction: (row) => react_1.default.createElement(DataTable_1.TextCell, null, row.columns.registerState ? 'Yes' : 'No'),
        },
        tableColumns[1],
    ];
    return (react_1.default.createElement(classifiers_1.ClassifierAdminPage, { entity: shared_1.jurisdictionEntityName, storageClientFilter: storageClientFilter, title: t('defaultClassifiers.state'), tableColumns: props.enableRegisterState ? tableColumnsWithRegisterState : tableColumns, fullTextSearchField: 'search', getEntityTitle: getEntityTitle, entityDetailsComponent: props.enableRegisterState ? EntityDetailsComponentWithRegisterState : EntityDetailsComponent, hideCreate: true, partialUpdate: true, formConfig: props.enableRegisterState ? formConfigWithRegisterState : formConfig }));
};
exports.StateAdminPage = StateAdminPage;
